/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, SAISON){
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;

	// <詳細>question
	const questionChange = () => {
		$('.js-questionary-btn-yes').on('click', (e) => {
			$('.js-questionary-btnWrap').remove();
			$('.js-questionary-yes').addClass(a);
		});
		$('.js-questionary-btn-no').on('click', (e) => {
			$('.js-questionary-btnWrap').remove();
			$('.js-questionary-no').addClass(a);
		});
	};

	// <詳細>構造化データ
	const structuredData = () => {
		let $thisId = $path.split('/')[$path.split('/').length -1].replace('.html', '');

		const req = new XMLHttpRequest();
		req.open('get', '/support/question/faq.csv', true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');
			tmp.pop();
			
			tmp.forEach((val, idx) => {
				const col = val.split(',').filter(Boolean);
				let urlIndex = tmp[0].split(',').indexOf('URL');
				let qIndex = tmp[0].split(',').indexOf('Question');
				let aIndex = tmp[0].split(',').indexOf('Answer');
				let thisUrl = col[urlIndex];
				let thisQ = col[qIndex];
				let thisA = col[aIndex];
				if(thisUrl.indexOf($thisId) !== -1) {
					let appendSrc =
					'{"@context": "http://schema.org/", "@type": "FAQPage",' +
					'"mainEntity": [{"@type": "Question",' +
					'"name": "'+ thisQ +'",' +
					'"acceptedAnswer": {'+
					'"@type": "Answer",'+
					'"text": "'+ thisA +'"}}]}';

					$('.jsonld-script').append(appendSrc);
				}
			});
		};
	};

	// ====================================================================

	if($('.question-detail-questionary').length) {
		questionChange();
	}
	if($path.indexOf('/support/question/detail/') !== -1) {
		structuredData();
	}

})(window.jQuery, window.SAISON);
